import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const serviceCouponDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "优惠券编码",
            prop: "couponCode",
            type: 'input',
          
        }, 
        {
            label: "优惠券名称",
            prop: "couponName",
            type: 'input',
           
        }, 
        {
            label: "金额",
            prop: "discountAmount",
            type: 'input',
        },
        {
            label: "领取人姓名",
            prop: "recipientName",
            type: 'input',
        
        }, 
        {
            label: "优惠券状态",
            prop: "status",
            type: 'select',
            dicData: DIC.PRODUCT_COUPON_USE_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        },
       
        {
            label: "领取时间",
            prop: "collectionTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "使用时间",
            prop: "useTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "bindingType",
            type: "input",
            hide:true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};